export function getViewingCopy(count) {
  if (count === 0) {
    return {
      title: 'New listing',
      description: 'Be the first to tour this home.',
    };
  }

  if (count < 10) {
    return {
      title: 'Getting attention',
      description: `It’s been toured ${count} time${count > 1 ? 's' : ''}.`,
    };
  }

  if (count < 50) {
    return {
      title: 'Popular home',
      description: `It’s been toured ${count} times. Don’t miss out!`,
    };
  }

  if (count < 200) {
    return {
      title: 'Very popular',
      description: `Over ${count} verified tours already.`,
    };
  }

  return {
    title: 'Hot property',
    description: `It’s been toured ${count.toLocaleString()} times. Tour it before it’s gone!`,
  };
}
